import React, { useEffect, useState } from 'react'
import cx from 'classnames'

import Image from '@/image.js'
import { Arrow } from '@/svgs.js'

const PressModule = ({ content }) => {
  const [active, setActive] = useState(0)
  const slideshow = React.createRef()
  useEffect(() => {
    const Flickity = require('flickity')
    const s = slideshow.current
    const flky = new Flickity(s, {
      contain: true,
      wrapAround: true,
      watchCSS: true,
      pageDots: false,
      cellAlign: 'center',
      prevNextButtons: false
    })
    setTimeout(() => {
      flky.resize()
    }, 500)
    flky.on('select', index => setActive(index))
    // return () => {
    //   flky.destroy()
    // }
  })
  return (
    <div className='x pb15 press__items'>
      <div className='container--xl ma ac'>
        <h2 className='mb0 pb0'>{content.title}</h2>
        <div className='x p15 press__slideshow' ref={slideshow}>
          {content.pressItems.map((press, i) => (
            <div className={cx('press__items-single ac x', {
              'is-active': active === i
            })} key={press._rev} onClick={() => setActive(i)}>
              <h3 className='h2'>{press.quote}</h3>
              <Image imageId={press.imageId} className='x' />
              <a className='event__single-link h5 mt15 small caps medium f jcc aic' href={press.url} rel='noopener noreferrer' target='_blank'>
                Read More <Arrow className='ml05' />
              </a>
            </div>
          ))}
        </div>
        <div className='x press__text'>
          {content.pressItems.map((press, i) => (
            <div className={cx('press__text-single px15 container--m ma ac x', {
              'is-active': active === i
            })} key={press._rev}>
              <h3 className='h3 mt0 mb1'>{press.quote}</h3>
              <a className='event__single-link h5 mt0 p0 small caps medium f jcc aic' href={press.url} rel='noopener noreferrer' target='_blank'>
                Read More <Arrow className='ml05' />
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PressModule